package com.merkost.handpass.admin.auth

import com.merkost.handpass.api.enums.AdminRole

sealed interface AuthState {
    data object Loading : AuthState
    data object LoggedOut : AuthState
    data class NotAdmin(val email: String) : AuthState
    data class Error(val message: String) : AuthState
    data class LoggedIn(
        val session: AuthSession,
        val role: AdminRole
    ) : AuthState
}
